<div class="header">
  {{ LL.addMacros.title() }}
  <cs-icon-button icon="close" (click)="onCloseClick()"></cs-icon-button>
</div>

<div class="content">
  <cs-form-field [label]="LL.addMacros.labels.foodName()">
    <cs-input [(value)]="foodName" [placeholder]="LL.addMacros.placeholders.enterFoodName()"></cs-input>
  </cs-form-field>

  <div class="macro-inputs">
    <cs-form-field [label]="LL.editFood.nutrients.calories()">
      <cs-input-measure type="nutrient_kcal" [lockUnit]="true" [(canonValue)]="calories" [emitDoneEventOnEveryKeypress]="true">
      </cs-input-measure>
    </cs-form-field>

    <cs-form-field [label]="LL.editFood.nutrients.protein()">
      <cs-input-measure type="nutrient_g" [lockUnit]="true" [(canonValue)]="protein" [emitDoneEventOnEveryKeypress]="true">
      </cs-input-measure>
    </cs-form-field>

    <cs-form-field [label]="LL.editFood.nutrients.fat()">
      <cs-input-measure type="nutrient_g" [lockUnit]="true" [(canonValue)]="fat" [emitDoneEventOnEveryKeypress]="true">
      </cs-input-measure>
    </cs-form-field>

    <cs-form-field [label]="LL.editFood.nutrients.carbohydrate()">
      <cs-input-measure type="nutrient_g" [lockUnit]="true" [(canonValue)]="carbohydrates"
        [emitDoneEventOnEveryKeypress]="true">
      </cs-input-measure>
    </cs-form-field>

    <cs-form-field [label]="LL.editFood.nutrients.fiber()">
      <cs-input-measure type="nutrient_g" [lockUnit]="true" [(canonValue)]="fiber" [emitDoneEventOnEveryKeypress]="true">
      </cs-input-measure>
    </cs-form-field>

    <cs-form-field [label]="LL.editFood.nutrients.cholesterol()">
      <cs-input-measure type="nutrient_mg" [lockUnit]="true" [(canonValue)]="cholesterol"
        [emitDoneEventOnEveryKeypress]="true">
      </cs-input-measure>
    </cs-form-field>
  </div>

  @if (showCalorieWarning) {
    <cs-text-alert type="warning"
    [message]="LL.addMacros.warnings.caloriesMismatch()"></cs-text-alert>
  }
</div>

<div class="actions">
  <cs-button small primary (click)="onSaveClick()">{{ LL.common.buttons.save() }}</cs-button>
  <cs-button small secondary (click)="onCancelClick()">{{ LL.common.buttons.cancel() }}</cs-button>
</div>